import { useAuth } from "../auth/AuthContext";
import { listSuppliers } from "../api/suppliersApi";
import { useAsyncData } from "../lib/useAsyncData";

export function useSupplierOptions() {
  const { ensureFreshToken } = useAuth();
  return useAsyncData(() => ensureFreshToken().then((token) => listSuppliers(token)), []);
}

export interface SupplierSelectProps {
  id: string;
  label: string;
  value: string;
  onChange: (supplierId: string) => void;
  required?: boolean;
}

/** `GET /suppliers`-backed dropdown — used by the product form (§10.2) and purchase
 * order creation. Always optional in practice (`InventoryItem.supplier_id` is nullable),
 * so always renders a "no supplier" option. */
export function SupplierSelect({ id, label, value, onChange, required }: SupplierSelectProps) {
  const suppliersState = useSupplierOptions();
  const suppliers = suppliersState.data ?? [];

  return (
    <div className="sl-field">
      <label className="sl-field__label" htmlFor={id}>
        {label}
      </label>
      <select
        id={id}
        className="sl-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        disabled={suppliersState.loading}
      >
        <option value="">No supplier</option>
        {suppliers.map((supplier) => (
          <option key={supplier.id} value={supplier.id}>
            {supplier.name}
          </option>
        ))}
      </select>
      {suppliersState.error ? <p className="sl-field__error">{suppliersState.error}</p> : null}
    </div>
  );
}
